import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Input } from '@/ui/atoms/Input'
import { Icon } from '@/ui/atoms/Icon'
import React from 'react'
import { cn } from '@/utils/ui'

import { Error } from '../Error'
import { Width } from '../Width'
import { EMailField } from '@/payload-types'
import { FormLabel } from '@/ui/atoms/FormLabel'

export const Email: React.FC<
  EMailField & {
    errors: Partial<
      FieldErrorsImpl<{
        [x: string]: any
      }>
    >
    register: UseFormRegister<FieldValues>
  }
> = ({ name, description, errors, label, register, required = false, width, icon }) => {
  const isValidEmail = (value: string) => {
    if (!required && value === '') {
      return true
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const valid = emailRegex.test(value)
    return valid
  }

  return (
    <Width width={width ?? 100}>
      <div>
        <div className="grid gap-1 mb-2">
          <FormLabel htmlFor={name} description={description}>
            {label}
          </FormLabel>
        </div>
        <div className="relative">
          {icon && (
            <div className="absolute inset-y-0 left-0 flex items-center justify-center w-8">
              <Icon name={icon} className="h-4 w-4 text-text-base" />
            </div>
          )}
          <Input
            id={name}
            type="email"
            {...register(name, {
              required: required ?? false,
              validate: (value) => isValidEmail(value),
            })}
            hasError={errors[name] ? true : false}
            className={cn(
              '!text-body-XS-regular',
              'text-text-base placeholder:text-text-faded',
              icon && 'pl-8',
            )}
          />
        </div>
        {errors[name] && <Error />}
      </div>
    </Width>
  )
}

//TODO: styling
